import { Routes, RouterModule } from "@angular/router";
import { MultiStationDesignComponent } from "./multi-station-design/multi-station-design.component";
import { MultiStationViewVisitorsComponent } from "./multi-station-view-visitors/multi-station-view-visitors.component";
import { MultiStationVisiteeMaintenanceComponent } from "./multi-station-visitee-maintenance/multi-station-visitee-maintenance.component";
import { MultiStationCurrentVisitorsComponent } from "./multi-station-current-visitors/multi-station-current-visitors.component";
import { MultiStationBlockedVisitorsComponent } from "./multi-station-blocked-visitors/multi-station-blocked-visitors.component";
import { MultiStationViewLogsComponent } from "./multi-station-view-logs/multi-station-view-logs.component";
import { MultiStationViewLogVisitorComponent } from "./multi-station-view-logs/multi-station-view-log-visitor/multi-station-view-log-visitor.component";
import { MultiStationPreRegistrationComponent } from "./multi-station-pre-registration/multi-station-pre-registration.component";
import { MultiStationVerifyVisitorComponent } from "./multi-station-verify-visitor/multi-station-verify-visitor.component";
import { MultiStationVisitorTypeMaintenanceComponent } from "./multi-station-visitor-type-maintenance/multi-station-visitor-type-maintenance.component";
import { MultiStationLocationMaintenanceComponent } from "./multi-station-location-maintenance/multi-station-location-maintenance.component";
import { MultiStationSettingsComponent } from "./multi-station-settings/multi-station-settings.component";
import { MultiStationReasonMaintenanceComponent } from "./multi-station-reason-maintenance/multi-station-reason-maintenance.component";
import { MultiStationNotificationMaintenanceComponent } from "./multi-station-notification-maintenance/multi-station-notification-maintenance.component";
import { AuthguardService } from "../master/services";
import { MultiStationManualLookupSuComponent } from "./multi-station-manual-lookup-su/multi-station-manual-lookup-su.component";

export const VisitorMultiStationRoutes: Routes = [
	// { path: "operator", data: { title: "VPP Operator" }, component: VppOperatorComponent },
	// { path: "operator/:VisitorID", data: {title: "VPP Offender Lookup"}, component: VppOperatorLookupComponent},

	// { path: 'location', redirectTo: '/visitor/location', pathMatch: 'full' },
	{
		path: "location",
		data: { title: "Location Maintenance" },
		component: MultiStationLocationMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "passdesign",
		data: { title: "Pass Designer" },
		component: MultiStationDesignComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "viewvisitor",
		data: { title: "View Visitors" },
		component: MultiStationViewVisitorsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "offenderlookup",
		data: { title: "Offender Lookup (SU Only)" },
		component: MultiStationManualLookupSuComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "visiteemaintenance",
		data: { title: "Visitee Maintenance" },
		component: MultiStationVisiteeMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "currentvisitors",
		data: { title: "Current Visitors" },
		component: MultiStationCurrentVisitorsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "blockedvisitors",
		data: { title: "Blocked Visitors" },
		component: MultiStationBlockedVisitorsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "viewlog",
		data: { title: "View Visitor Logs" },
		component: MultiStationViewLogsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "viewlog/:VisitorPassDetailID",
		data: { title: "View Visitor Logs" },
		component: MultiStationViewLogVisitorComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "preregistration",
		data: { title: "Pre-Registration" },
		component: MultiStationPreRegistrationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "verifyvisitor/:VisitorPassID",
		data: { title: "Verify Visitor" },
		component: MultiStationVerifyVisitorComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "visitortype",
		data: { title: "Visitor Type Maintenance" },
		component: MultiStationVisitorTypeMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "settings",
		data: { title: "CAASS Visitors Settings" },
		component: MultiStationSettingsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "reasonmaintenance",
		data: { title: "Visit Reason Maintenance" },
		component: MultiStationReasonMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "notificationmaintenance",
		data: { title: "Notification Maintenance" },
		component: MultiStationNotificationMaintenanceComponent,
		canActivate: [AuthguardService],
	},
];
